import Vue from 'vue';
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';

Vue.component('VueCropper', VueCropper);
